import FilledButton from "../../../component/FilledButton";
import BtnLoader from "../../../layout/BtnLoader";

const RetryPop = ({ updateCourse, updateLoad, tittle="Course Update" }) => {
    return (
        <div className="pop_content delete_model">
            <h2 className="retry_pop_title">{tittle}</h2>
            <div className="text-center mb-4">
                {
                    updateLoad ? (
                        <button className="cursor_pointer btn_primary prof btn btn_primary_delete"><BtnLoader/></button>
                    ) : (
                        <FilledButton className="cursor_pointer btn_primary prof btn btn_primary_delete" onClick={() => updateCourse()} value="PAY NOW" />
                    )
                }
            </div>
        </div>
    )
};

export default RetryPop